import type { RedoCart } from "@redotech/merchant-sdk/rpc/schema/redo-supplies/redo-cart";
import {
  hasSafetyStockAttribute,
  ORDER_INTERVAL_ATTRIBUTE,
  SUPPLIES_PROMOTION_ATTRIBUTE,
} from "@redotech/redo-supplies-common/cart-attributes";

export function suppliesCartAnalytics(cart: RedoCart | null | undefined) {
  const items = cart?.items ?? [];
  return {
    cartItemCount: items.length,
    cartQuantity: items.reduce((sum, item) => sum + item.quantity, 0),
    cartSubtotal: items.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0,
    ),
    currency: items[0]?.currency,
    hasDestinationLocation: cart?.destinationLocationId != null,
    hasFreeItem: items.some((item) =>
      item.attributes.some(
        (attribute) => attribute.key === SUPPLIES_PROMOTION_ATTRIBUTE,
      ),
    ),
    hasInventoryTriggeredItem: items.some((item) =>
      hasSafetyStockAttribute(item.attributes),
    ),
    hasSubscriptionItem: items.some((item) =>
      item.attributes.some(
        (attribute) => attribute.key === ORDER_INTERVAL_ATTRIBUTE,
      ),
    ),
  };
}

export function fundingSourceAnalytics(reference: {
  source: string;
  priority?: string;
}) {
  return {
    paymentSource: reference.source,
    paymentPriority: reference.priority,
  };
}
